import { useSearchParams } from "react-router-dom";

export interface BuildSearchParams {
  /**
   * The UUID of the step to show in the step drawer.
   */
  stepUuid?: string | null;
  /**
   * The UUID of the job to show in the job drawer.
   */
  jobUuid?: string | null;
  /**
   * Indicates whether the step drawer should be open.
   */
  open?: string | null;
}

/**
 * Hook to extract build-page related query parameters from the URL.
 */
export default function useQueryParams(): BuildSearchParams {
  const [searchParams] = useSearchParams();
  const stepUuid = searchParams.get("sid");
  const jobUuid = searchParams.get("jid");
  const open = searchParams.get("open");

  return { stepUuid, jobUuid, open };
}
